import { createContext, useContext, ReactNode, useState } from 'react';

interface EntityLayoutContextValue {
  titleWidth: number;
  registerTitleWidth: (width: number) => void;
}

const EntityLayoutContext = createContext<EntityLayoutContextValue | undefined>(undefined);

interface EntityLayoutProviderProps {
  children: ReactNode;
}

export function EntityLayoutProvider({ children }: EntityLayoutProviderProps) {
  const [titleWidth, setTitleWidth] = useState(0);

  const registerTitleWidth = (width: number) => {
    setTitleWidth(prev => Math.max(prev, width));
  };

  const value = {
    titleWidth,
    registerTitleWidth,
  };

  return <EntityLayoutContext value={value}>{children}</EntityLayoutContext>;
}

export function useEntityLayout() {
  const context = useContext(EntityLayoutContext);
  if (context === undefined) {
    throw new Error('useEntityLayout must be used within an EntityLayoutProvider');
  }
  return context;
}
